const popup = document.querySelector('[data-mk-newsletter]');
if (popup) {
  const key = 'mk_newsletter_seen';
  const delayMs = 30000; // 30 seconds after page load

  const close = () => {
    popup.classList.remove('is-visible');
    localStorage.setItem(key, '1');
  };

  popup.addEventListener('click', (event) => {
    const action = event.target.getAttribute('data-action');
    if (action === 'close') close();
  });

  const show = () => {
    if (localStorage.getItem(key)) return;
    popup.classList.add('is-visible');
  };

  window.setTimeout(show, delayMs);
}
